// extracted by mini-css-extract-plugin
module.exports = {"button":"create-role-modal_button_2n_T1"};